import React, { useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { checkAndFocus, focusElemnt, navigationWithArrow } from '../utils/helpers';
import MButton from './MButton';
const AlertModalForSuccessPrint = (props) => {
    const { open, onClose, message, onConfirm } = props;
    useEffect(() => {
        requestAnimationFrame(() => checkAndFocus(`printYesBtn`));
    }, [open])

    const handleClose = () => {
        onClose(false);
    };
    const handleConfirm = () => {
        onConfirm();
    }

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    style: {
                        width: '400px',
                        maxWidth: 'none',
                        maxHeight: 'none',
                        padding: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#E0EFD8'
                    },
                }}
            >
                <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
                    <>
                        <CheckCircleIcon style={{ color: '#3C763C', fontSize: '40px' }} />
                        <span style={{ color: '#3C763C', fontWeight: '500', lineHeight: '28px', fontSize: '20px' }}>Success !</span>
                    </>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{
                        fontSize: '14px',
                        fontWeight: 500,
                        justifyContent: 'center',
                        alignItems: 'center',
                        lineHeight: '22px',
                        textAlign: "center"
                    }}>
                        {message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', gap: '10px', justifyContent: "center !important" }}>
                    <MButton
                        variant="outlined"
                        onClick={handleClose}
                        id='printNoBtn'
                        onKeyDown={(event) => {
                            navigationWithArrow(event, "printYesBtn", "printYesBtn", () => {
                                handleClose()
                            })
                        }}
                        btnName='No'
                    />
                    <MButton
                        onClick={handleConfirm}
                        id='printYesBtn'

                        onKeyDown={(event) => {
                            navigationWithArrow(event, "printNoBtn", "printNoBtn", () => {
                                handleConfirm()
                            })
                        }}
                        btnName='Yes'
                    />

                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default AlertModalForSuccessPrint;
